import { render, staticRenderFns } from "./edit-address.vue?vue&type=template&id=27cf89ac&scoped=true&"
import script from "./edit-address.vue?vue&type=script&lang=tsx&"
export * from "./edit-address.vue?vue&type=script&lang=tsx&"
import style0 from "./edit-address.vue?vue&type=style&index=0&id=27cf89ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf89ac",
  null
  
)

export default component.exports